(function() {
  var container = document.getElementById('hero-collage');
  if (!container) return;

  var speed = parseInt(container.getAttribute('data-speed')) || 100;
  var freezeDuration = parseInt(container.getAttribute('data-freeze')) || 1000;
  var images = container.querySelectorAll('.collage-img');
  var totalImages = images.length;
  if (totalImages === 0) return;

  var currentIndex = 0;
  var isFrozen = false;
  var freezeTarget = totalImages - 1;
  var glitchOffset = 0;
  var hardGlitch = false;

  var staticCanvas = document.getElementById('static-canvas');
  var ctx = staticCanvas ? staticCanvas.getContext('2d') : null;
  var glitchSlicesEl = document.getElementById('glitch-slices');
  var hardGlitchFlash = document.getElementById('hard-glitch-flash');
  var rgbSubpixel = document.getElementById('rgb-subpixel');
  var logoOverlay = document.getElementById('logo-overlay');
  var logoMain = logoOverlay ? logoOverlay.querySelector('.logo-main') : null;
  var logoRgbR = logoOverlay ? logoOverlay.querySelector('.logo-rgb-r') : null;
  var logoRgbB = logoOverlay ? logoOverlay.querySelector('.logo-rgb-b') : null;
  var wavePhase = 0;

  if (staticCanvas && ctx) {
    staticCanvas.width = 400;
    staticCanvas.height = 300;
  }

  function drawStatic() {
    if (!ctx) return;
    var imageData = ctx.createImageData(staticCanvas.width, staticCanvas.height);
    var data = imageData.data;
    var w = staticCanvas.width;
    var h = staticCanvas.height;

    for (var y = 0; y < h; y++) {
      var rowGlitch = Math.random() > 0.92;
      var rowColor = rowGlitch ? Math.floor(Math.random() * 3) : -1;

      for (var x = 0; x < w; x++) {
        var idx = (y * w + x) * 4;
        var v = Math.random() * 255;

        if (rowGlitch) {
          data[idx] = rowColor === 0 ? 255 : v * 0.8;
          data[idx + 1] = rowColor === 1 ? 255 : v * 0.6;
          data[idx + 2] = rowColor === 2 ? 255 : v * 0.7;
          data[idx + 3] = 200;
        } else {
          var colorBias = Math.random();
          if (colorBias > 0.85) {
            data[idx] = Math.random() * 255;
            data[idx + 1] = Math.random() * 50;
            data[idx + 2] = Math.random() * 100;
          } else if (colorBias > 0.7) {
            data[idx] = Math.random() * 50;
            data[idx + 1] = Math.random() * 255;
            data[idx + 2] = Math.random() * 100;
          } else if (colorBias > 0.55) {
            data[idx] = Math.random() * 80;
            data[idx + 1] = Math.random() * 100;
            data[idx + 2] = Math.random() * 255;
          } else {
            data[idx] = v;
            data[idx + 1] = v;
            data[idx + 2] = v;
          }
          data[idx + 3] = 160;
        }
      }
    }

    var bandCount = Math.floor(Math.random() * 4) + 1;
    for (var b = 0; b < bandCount; b++) {
      var bandY = Math.floor(Math.random() * h);
      var bandH = Math.floor(Math.random() * 15) + 3;
      var bandColor = [Math.random() * 255, Math.random() * 255, Math.random() * 255];
      for (var by = bandY; by < Math.min(bandY + bandH, h); by++) {
        for (var bx = 0; bx < w; bx++) {
          var bidx = (by * w + bx) * 4;
          data[bidx] = bandColor[0];
          data[bidx + 1] = bandColor[1];
          data[bidx + 2] = bandColor[2];
          data[bidx + 3] = 220;
        }
      }
    }

    ctx.putImageData(imageData, 0, 0);
    requestAnimationFrame(drawStatic);
  }

  function showImage(index) {
    for (var i = 0; i < totalImages; i++) {
      if (i === index) {
        images[i].style.opacity = '1';
        images[i].style.zIndex = '10';
      } else {
        images[i].style.opacity = '0';
        images[i].style.zIndex = '0';
      }
    }
  }

  function applyGlitchTransform() {
    var activeImg = images[currentIndex];
    if (!activeImg) return;
    var transform = 'translateX(' + glitchOffset + 'px)';
    if (hardGlitch) {
      transform += ' skewX(' + ((Math.random() - 0.5) * 25) + 'deg) skewY(' + ((Math.random() - 0.5) * 5) + 'deg)';
      activeImg.style.filter = 'saturate(4) contrast(2) brightness(1.3)';
    } else {
      activeImg.style.filter = 'saturate(1.3) contrast(1.1)';
    }
    activeImg.style.transform = transform;

    if (logoOverlay) logoOverlay.style.transform = transform;
    if (logoMain) {
      logoMain.style.filter = 'brightness(0) invert(1)' + (hardGlitch ? ' saturate(4) contrast(2) brightness(1.3)' : '');
      logoMain.style.opacity = isFrozen ? '0.95' : '0.9';
    }
    if (!isFrozen && logoRgbR && logoRgbB) {
      logoRgbR.style.display = 'block';
      logoRgbB.style.display = 'block';
      logoRgbR.style.opacity = '0.4';
      logoRgbB.style.opacity = '0.4';
      logoRgbR.style.transform = 'translate(' + (hardGlitch ? 8 : 3) + 'px, 0)';
      logoRgbB.style.transform = 'translate(' + (hardGlitch ? -6 : -2) + 'px, ' + (hardGlitch ? 3 : 0) + 'px)';
    } else if (logoRgbR && logoRgbB) {
      logoRgbR.style.display = 'none';
      logoRgbB.style.display = 'none';
    }
  }

  function generateGlitchSlices() {
    if (!glitchSlicesEl) return;
    glitchSlicesEl.innerHTML = '';
    if (isFrozen) return;

    if (Math.random() > 0.3) {
      var sliceCount = Math.floor(Math.random() * 8) + 3;
      var colors = ['rgba(255,0,0,0.4)', 'rgba(0,255,0,0.4)', 'rgba(0,0,255,0.4)', 'rgba(255,0,255,0.4)', 'rgba(0,255,255,0.4)', 'rgba(255,255,0,0.3)'];
      for (var i = 0; i < sliceCount; i++) {
        var slice = document.createElement('div');
        slice.style.cssText = 'position:absolute;left:0;right:0;pointer-events:none;mix-blend-mode:screen;';
        slice.style.top = (Math.random() * 100) + '%';
        slice.style.height = (Math.random() * 10 + 1) + '%';
        slice.style.transform = 'translateX(' + ((Math.random() - 0.5) * 150) + 'px)';
        slice.style.background = colors[Math.floor(Math.random() * colors.length)];
        glitchSlicesEl.appendChild(slice);
      }

      glitchOffset = (Math.random() - 0.5) * 100;
      setTimeout(function() {
        glitchOffset = 0;
        if (glitchSlicesEl) glitchSlicesEl.innerHTML = '';
        applyGlitchTransform();
      }, 20 + Math.random() * 60);
    }
    applyGlitchTransform();
  }

  function runShuffle() {
    if (isFrozen) {
      setTimeout(function() {
        isFrozen = false;
        freezeTarget = (freezeTarget - 1 + totalImages) % totalImages;
        runShuffle();
      }, freezeDuration);
      return;
    }

    var shuffleInterval = setInterval(function() {
      if (isFrozen) {
        clearInterval(shuffleInterval);
        runShuffle();
        return;
      }
      currentIndex = (currentIndex + 1) % totalImages;
      if (currentIndex === freezeTarget) {
        isFrozen = true;
        glitchOffset = 0;
        hardGlitch = false;
        if (glitchSlicesEl) glitchSlicesEl.innerHTML = '';
        if (hardGlitchFlash) hardGlitchFlash.style.display = 'none';
      }
      showImage(currentIndex);
      applyGlitchTransform();
    }, speed);
  }

  setInterval(function() {
    if (!isFrozen) generateGlitchSlices();
  }, 80);

  setInterval(function() {
    if (isFrozen) {
      hardGlitch = false;
      if (hardGlitchFlash) hardGlitchFlash.style.display = 'none';
      return;
    }
    if (Math.random() > 0.75) {
      hardGlitch = true;
      if (hardGlitchFlash) {
        hardGlitchFlash.style.display = 'block';
        hardGlitchFlash.style.background = 'linear-gradient(' + (Math.random() * 360) + 'deg, rgba(255,0,0,0.25), rgba(0,255,255,0.2), rgba(255,0,255,0.2))';
      }
      applyGlitchTransform();
      setTimeout(function() {
        hardGlitch = false;
        if (hardGlitchFlash) hardGlitchFlash.style.display = 'none';
        applyGlitchTransform();
      }, 60 + Math.random() * 120);
    }
  }, 300);

  function animateWave() {
    wavePhase += 0.15;
    if (rgbSubpixel) {
      rgbSubpixel.style.transform = 'translateY(' + (Math.sin(wavePhase) * 3) + 'px)';
    }
    requestAnimationFrame(animateWave);
  }

  showImage(0);
  drawStatic();
  animateWave();
  runShuffle();
})();
